 // eslint-disable-next-line 
export default {
  title: {
    required: true,
    label: 'Title',
  },
};
